export enum EInsideElement {
    PO = 0,
    DR = 1,
    FP = 2,
    AB = 3,
    S = 4,
    SS = 5,
    B = 6,
    PB = 7,
    BR = 8,
    BRS = 9,
    DK = 10,
    TL = 11,
    TR = 12,
    TP = 13,
    THM = 14,
    TM = 15,
    TH = 16,
    TC = 17,
    HTC = 18,
    BA = 19,
    T = 20,
    DN = 21,
    SP = 22,
    HB = 23,
    SB = 24,
    SG = 25,
    BH = 26,
    PT = 27,
    DT = 28,
    IT = 29,
    RH = 30,
    PH = 31,
    BS = 32,
    LC = 33,
    RO = 34,
    PW = 35,
    A = 36,
    F = 37,
    DW = 38,
    W = 39,
    WT = 40,
    CU = 41,
    AS = 42,
    MS = 43,
    R = 44,
    BO = 45,
    SU = 46,
    OT = 47,
}